import { themr } from 'analytics-ui/theme/themr';
import PropTypes from 'prop-types';
import { Select } from '@nextiva/next-ui';
import * as React from 'react';

import Styles from './EntriesPerPage.module.scss';

const makeOptions = (opts) =>
  opts.map(value => ({
    value,
    label: String(value),
  }));

const DEFAULT_SIZE = 25;

function EntriesPerPage({ value = DEFAULT_SIZE, theme, onChange }) {
  const handleChange = ({ value: v }) => onChange(v);
  const options = makeOptions([25, 50, 75, 100]);

  return (
    <div
      className={theme['entries-per-page']}
      data-testid="AnalyticsSpa-EntriesPerPage-Entries"
    >
      <span>Show</span>
      <Select
        className={theme['select']}
        options={options}
        value={value}
        onChange={handleChange}
      />
      <span>entries</span>
    </div>
  );
}
EntriesPerPage.propTypes = {
  value: PropTypes.number,
  disabled: PropTypes.bool,
  theme: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};

//@ts-ignore until typings in place
export default themr(React.memo(EntriesPerPage), Styles);
